<div class="header">
  <div class="flex-grow-1" style="font-size: 1.5rem">
    Customer User Automatic Deactivation Settings
  </div>
  <div
    class="flex-shrink-1"
    pTooltip="Generate a CSV showing Portal customer users and equivalent CRM Contacts"
  >
    <button
      [disabled]="csvDownloading"
      pButton
      label="Get CRM sync CSV"
      [icon]="csvDownloading ? 'fa fa-spin fa-spinner' : 'fa fa-address-book-o'"
      (click)="getCRMCSV()"
    ></button>
  </div>
</div>
<div class="">
  <div class="content-container">
    <p-table
      [value]="deactivationSettings"
      [responsive]="true"
      resizableColumns="true"
      class="fixed-table"
      selectionMode="single"
      [(selection)]="selectedSetting"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Customer Type</th>
          <th>Warning Days Since Last Login</th>
          <th>Deactivation Days Since Last Login</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr (click)="editSetting(item)">
          <td>{{ item.name }}</td>
          <td
            pTooltip="Number of days since last login before user is sent a warning about deactivation"
            style="text-align: center"
          >
            {{ item.accessWarnDays | number }}
          </td>
          <td
            pTooltip="Number of days since warning before user is automatically deactivated"
            style="text-align: center"
          >
            {{ item.accessDeactivateDays | number }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="">
  <div class="content-container">
    <div class="filterPanel mb-3">
      <div class="flex grid-gap-15">
        <div class="pt-1">
          <input pInputText [(ngModel)]="searchCustomer" placeholder="Search Customer" />
        </div>
        <div class="pt-1">
          <input pInputText [(ngModel)]="searchUser" placeholder="Search User" />
        </div>
        <p-dropdown
          id="auditType"
          appendTo="body"
          placeholder="Filter audit type"
          [options]="auditTypeOptions"
          [(ngModel)]="selectedAuditType"
          (ngModelChange)="onAuditTypeChanged()"
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <div>
          <button
            class="ui-button-secondary"
            pButton
            label="Reset"
            icon="fa fa-undo"
            (click)="reset()"
          ></button>
          <button pButton label="Search" icon="fa fa-search" (click)="search()"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="content-container">
    <p-table
      #dataTable
      *ngIf="viewData"
      selectionMode="single"
      [value]="viewData"
      [rows]="numberOfRows"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      [first]="first"
      [lazy]="true"
      [rowsPerPageOptions]="[20, 50, 100]"
      [pageLinks]="8"
      [totalRecords]="filteredData.length"
      (onLazyLoad)="onGridLazyLoad($event)"
      resizableColumns="true"
      styleClass="inbox-data-table dataTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Customer</th>
          <th>User</th>
          <th>Email</th>
          <th>Warned</th>
          <th>Deactivated</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <ng-container *ngIf="letUser(user) as user">
          <tr [pSelectableRow]="user">
            <td>
              <a href="/app/organisations/{{ user.organisationId }}" target="_blank">{{
                user.organisationName
              }}</a>
            </td>
            <td>
              <a href="/app/vmeuserdetails/{{ user.userId }}?orgTypeId=1" target="_blank">{{
                user.userName
              }}</a>
            </td>
            <td>
              {{ user.userEmail }}
            </td>
            <td>
              {{ user.warnDate | datex : "ddd DD MMM 'YY HH:mm" }}
            </td>
            <td>
              {{ user.deactivationDate | datex : "ddd DD MMM 'YY HH:mm" }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  *ngIf="selectedSetting"
  header="Edit Deactivation Setting"
  [(visible)]="showSettingDialog"
  [responsive]="true"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '500px', height: '320px' }"
>
  <form [formGroup]="form" (ngSubmit)="saveSetting(selectedSetting)">
    <div style="padding: 10px">
      <div class="ui-g" style="position: relative; height: 250px">
        <div class="ui-g-12">
          <div
            class="ui-grid-col-8"
            pTooltip="Number of days since last login to send warning email"
          >
            <label>Warning Days Since Last Login</label>
          </div>
          <div class="ui-grid-col-4">
            <div style="width: 100%">
              <input
                pInputText
                type="text"
                id="accessWarnDays"
                formControlName="accessWarnDays"
                step="1"
              />
              <small class="text-danger" *ngIf="form.get('accessWarnDays').hasError('required')">
                This field is required.
              </small>
            </div>
          </div>
        </div>

        <div class="ui-g-12">
          <div
            class="ui-grid-col-8"
            pTooltip="Number of days without logging in before deactivation"
          >
            <label>Days Since Last Login</label>
          </div>
          <div class="ui-grid-col-4">
            <input
              pInputText
              type="number"
              id="accessDeactivateDays"
              formControlName="accessDeactivateDays"
              step="1"
            />
            <div
              class="ui-error"
              *ngIf="
                ctrls['accessDeactivateDays'].invalid &&
                (ctrls['accessDeactivateDays'].dirty || ctrls['accessDeactivateDays'].touched)
              "
            >
              <small
                class="text-danger"
                *ngIf="form.get('accessDeactivateDays').hasError('required')"
              >
                This field is required.
              </small>
              <small class="text-danger" *ngIf="form.get('accessDeactivateDays').hasError('min')">
                The minimum value for this field is
                {{ form.get('accessDeactivateDays').errors.min.min }}
              </small>
              <small class="text-danger" *ngIf="form.get('accessDeactivateDays').hasError('max')">
                The maximum value for this field is
                {{ form.get('accessDeactivateDays').errors.max.max }}
              </small>
            </div>
          </div>
        </div>

        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="showSettingDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="submit"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
          ></button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
